exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-setting-question .setting-number-box{-ms-flex-pack:end;justify-content:flex-end;-ms-flex-negative:0;flex-shrink:0}.item-setting-question .setting-number-box,.item-setting-question .setting-number-box .vnis{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.item-setting-question .setting-number-input{-ms-flex:1;flex:1;overflow:hidden}.item-setting-question .setting-number-button{width:24px;-webkit-appearance:none;transition:background .5s ease;background-color:#fff;color:#666;border:0;cursor:pointer;font-size:20px;margin:0;outline:none;vertical-align:middle}", ""]);

// exports
